module.exports = __webpack_public_path__ + "010dba2ed4f0fa9a181d9339d8b31086.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/team_daniel_mobile.jpg
// module id = 667
// module chunks = 0